import { ViewLocalV2EventManagePage } from "./ViewLocalV2EventManagePage";

export default ViewLocalV2EventManagePage;
